module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp123_9006.2c598699.png";